import Flex from 'typescript-styled-flex'
import is from 'typescript-styled-is'
import styled, { ITheme } from '../../../theme'
import isLink from '../../../theme/styles/isLink'

const Button = styled(Flex.withComponent('a') as any)<IButtonProps>`
  ${isLink};
  min-height: ${({ size }) => (size ? 2.25 * size : 2.25)}em;
  padding: 0 0.75em;
  font-size: ${({ size }) => (size ? 1 * size : 1)}em;
  line-height: ${({ size }) => (size ? 1 * size : 1)}em;
  text-align: center;
  font-weight: 600;
  color: ${(props: ITheme) => props.theme.colors.palette.greyishBrown};
  border-radius: ${({ borderRadius }) =>
    borderRadius !== undefined ? `${borderRadius}px` : '3px'};

  align-items: center;
  justify-content: center;
  user-select: none;
  

  &:hover {
    cursor: pointer;
    background-color: ${({ theme }: ITheme) =>
      theme.colors.palette.pinkishGrey};
  }

  ${is('outline')`
    background-color: transparent;
    border: 1px solid ${(props: ITheme) =>
      props.theme.colors.palette.warmGreytThree};

    &:hover {
      color: ${(props: ITheme) => props.theme.colors.palette.emerald};
      border-color: ${(props: ITheme) => props.theme.colors.palette.emerald};
    }
  `}

  ${is('outline2')`
    background-color: transparent;
    border: 1px solid ${(props: ITheme) =>
          props.theme.colors.palette.emerald};
    color: ${(props: ITheme) => props.theme.colors.palette.emerald};

    &:hover {
    background-color: ${(props: ITheme) =>
          props.theme.colors.palette.pinkishGrey};
    }
  `}
  

  ${is('delete')`
    border: 1px solid #D83A3A;
          background-color: #D83A3A; 
    color: #fff;
    
    &:hover {
      border-color: ${(props: ITheme) => props.theme.colors.palette.reddish};
          color: ${(props: ITheme) => props.theme.colors.palette.reddish};
    }
  `}  
  
  ${is('adelete')`
    border: 1px solid ${(props: ITheme) => props.theme.colors.palette.airbnb};
          background-color: ${(props: ITheme) =>
            props.theme.colors.palette.airbnb}; 
    color: #fff;
    
    &:hover {
      border-color: #CC484C;
          background-color: #CC484C;
    }
  `}

  ${is('primary')`
    background-color: ${(props: ITheme) => props.theme.colors.palette.emerald};
    color: #fff;
    
    &:hover {
      background-color: #008735;
    }
    &:active {
      box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
    }
  `}


  ${is('info')`
    background-color: #0091f7;
    color: #fff;
    
    &:hover {
      background-color: #0068b3;
    }
    &:active {
      box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
    }
  `}

  ${is('small')`
    height: 1.5em;
    padding: 0 .25em;

    &:hover {
      background-color: ${(props: ITheme) =>
        props.theme.colors.palette.greyTwo};;
    }
  `}

  ${is('light')`
    background-color: #dfdfdf;
    color: #000;
  
    &:hover {
        background-color: ${(props: ITheme) =>
          props.theme.colors.palette.pinkishGrey};

    }
  `} 
  
  ${is('alight')`
    background-color: #ebedef;
    color: #000;
  
    &:hover {
        background-color: ${(props: ITheme) =>
          props.theme.colors.palette.pinkishGrey};

    }
  `}
  
  
  ${is('disabled')`
    color: white;
    background: #C2C2C2;
      &:hover {
        background-color: #C2C2C2
    }
  `}
  
    ${is('isDisabled')`
      color: ${(props: ITheme) => props.theme.colors.palette.pinkishGrey};
      background-color: ${(props: ITheme) =>
        props.theme.colors.palette.lightGrey};
      pointer-events: none;
  `}
    
  ${is('white')`
    background-color: white
  `}
  
  ${is('logout')`
    background: ${({ theme }: ITheme) => theme.colors.palette.reddish};
    color: white;
  `};
  
  ${is('service')`
    color: ${(props: ITheme) => props.theme.colors.palette.emerald};
    border: 1px solid ${(props: ITheme) => props.theme.colors.palette.emerald};
    background-color: white;
    
     &:hover {
      color: white;
      background-color: ${(props: ITheme) =>
        props.theme.colors.palette.emerald};
    }
    &:active {
     background-color: #008735;
    }
     &:focus {
     background-color: #008735;
    }
  `}
  
  ${is('disbledHover')`
      &:hover {
        background-color: none;
      };
  `};
`

export const Button2 = styled(Flex.withComponent('a') as any)<IButtonProps>`
  ${isLink};
  min-height: ${({ size }) => (size ? 2.25 * size : 2.25)}em;
    padding: 6px 30px;
    height: 34px;
  font-size: 12px;
  line-height: ${({ size }) => (size ? 1 * size : 1)}em;
  text-align: center;
  font-weight: 600;
  color: ${(props: ITheme) => props.theme.colors.palette.greyishBrown};
  border-radius: 4px;

    @media (max-width: ${props => props.theme.breakpoints.mobile}) {
        font-size: 11px;
    }
    
  align-items: center;
  justify-content: center;
  user-select: none;

  &:hover {
    cursor: pointer;
    background-color: ${({ theme }: ITheme) =>
  theme.colors.palette.pinkishGrey};
  }

  ${is('outline')`
    background-color: transparent;
    border: 1px solid ${(props: ITheme) =>
  props.theme.colors.palette.warmGreytThree};

    &:hover {
      color: ${(props: ITheme) => props.theme.colors.palette.emerald};
      border-color: ${(props: ITheme) => props.theme.colors.palette.emerald};
    }
  `}

  ${is('delete')`
    border: 1px solid ${(props: ITheme) => props.theme.colors.palette.airbnb};
          background-color: ${(props: ITheme) =>
  props.theme.colors.palette.airbnb}; 
    color: #fff;
    
    &:hover {
      border-color: ${(props: ITheme) => props.theme.colors.palette.reddish};
          color: ${(props: ITheme) => props.theme.colors.palette.reddish};
    }
  `}  
  
  ${is('adelete')`
    border: 1px solid ${(props: ITheme) => props.theme.colors.palette.airbnb};
          background-color: ${(props: ITheme) =>
  props.theme.colors.palette.airbnb}; 
    color: #fff;
    
    &:hover {
      border-color: #CC484C;
          background-color: #CC484C;
    }
  `}

  ${is('primary')`
    background-color: ${(props: ITheme) => props.theme.colors.palette.emerald};
    color: #fff;
    
    &:hover {
      background-color: #008735;
    }
    &:active {
      box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
    }
  `}


  ${is('info')`
    background-color: #0091f7;
    color: #fff;
    
    &:hover {
      background-color: #0068b3;
    }
    &:active {
      box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
    }
  `}

  ${is('small')`
    height: 1.5em;
    padding: 0 .25em;

    &:hover {
      background-color: ${(props: ITheme) =>
  props.theme.colors.palette.greyTwo};;
    }
  `}

  ${is('light')`
    background-color: #dfdfdf;
    color: #000;
  
    &:hover {
        background-color: ${(props: ITheme) =>
  props.theme.colors.palette.pinkishGrey};

    }
  `} 
  
  ${is('alight')`
    background-color: #ebedef;
    color: #000;
  
    &:hover {
        background-color: ${(props: ITheme) =>
  props.theme.colors.palette.pinkishGrey};

    }
  `}
  
  
  ${is('disabled')`
    color: gray;
    background: white;
    pointer-events: none;
  `}
  
    ${is('isDisabled')`
      color: ${(props: ITheme) => props.theme.colors.palette.pinkishGrey};
      background-color: ${(props: ITheme) =>
  props.theme.colors.palette.lightGrey};
      pointer-events: none;
  `}
    
  ${is('white')`
    background-color: white
  `}
  
  ${is('logout')`
    background: ${({ theme }: ITheme) => theme.colors.palette.reddish};
    color: white;
  `};
  
  ${is('service')`
    color: ${(props: ITheme) => props.theme.colors.palette.emerald};
    border: 1px solid ${(props: ITheme) => props.theme.colors.palette.emerald};
    background-color: white;
    
     &:hover {
      color: white;
      background-color: ${(props: ITheme) =>
  props.theme.colors.palette.emerald};
    }
    &:active {
     background-color: #008735;
    }
     &:focus {
     background-color: #008735;
    }
  `}
  
  ${is('disbledHover')`
      &:hover {
        background-color: none;
      };
  `};
`

export default Button
export interface IButtonProps {
  outline?: boolean
  outline2?: boolean
  onClick?: any
  primary?: boolean
  light?: boolean
  alight?: boolean
  adelete?: boolean
  small?: boolean
  disabled?: boolean
  logout?: boolean
  white?: boolean
  delete?: boolean
  isDisabled?: boolean
  size?: number
  service?: boolean
  info?: boolean
  disbledHover?: boolean
  borderRadius?: number
}
